export const QUICKBOOKS_BILL_URL = (externalId: string) =>
  `https://qbo.intuit.com/app/bill?txnId=${externalId}`;

export const QUICKBOOKS_INVOICE_URL = (externalId: string) =>
  `https://qbo.intuit.com/app/invoice?txnId=${externalId}`;
